import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="swipeable"
export default class extends Controller {
  static targets = ["sheet"];

  connect() {
    this.startY = 0;
    this.currentY = 0;
    this.dragging = false;
  }

  startDrag(event) {
    // Get the starting Y coordinate (supports touch and mouse)
    this.startY = event.type.includes("touch")
      ? event.touches[0].clientY
      : event.clientY;
    this.dragging = true;

    // Remove transition so the sheet sticks to the finger instantly
    this.sheetTarget.style.transition = "none";
  }

  drag(event) {
    if (!this.dragging) return;

    const y = event.type.includes("touch")
      ? event.touches[0].clientY
      : event.clientY;
    const delta = y - this.startY;

    // Only allow dragging DOWN (delta > 0)
    if (delta > 0) {
      if (event.cancelable) event.preventDefault(); // Stop background scrolling
      this.sheetTarget.style.transform = `translateY(${delta}px)`;
    }
  }

  endDrag(event) {
    if (!this.dragging) return;
    this.dragging = false;

    // Re-enable smooth transition for the snap back or close animation
    this.sheetTarget.style.transition =
      "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)";

    const y = event.type.includes("touch")
      ? event.changedTouches[0].clientY
      : event.clientY;
    const delta = y - this.startY;

    // If dragged down more than 100px, close the modal. Otherwise, snap back.
    if (delta > 100) {
      this.close();
    } else {
      this.sheetTarget.style.transform = ""; // Reset to default CSS
    }
  }

  close() {
    // Animate the sheet sliding completely off screen
    this.sheetTarget.style.transform = "translateY(100%)";

    // Wait for the animation to finish, then trigger your existing modal#close action
    setTimeout(() => {
      const closeBtn = this.element.querySelector(
        '[data-action*="modal#close"]',
      );
      if (closeBtn) closeBtn.click();
    }, 300);
  }
}
